import { MonetizableEnum } from '@ria-client/segment/enums';
import { DefaultEditorial } from './DefaultEditorial';
import { PaidNonAdvisoryClientRIA } from './PaidNonAdvisoryClientRIA';
import { PaidNonClientPromotionRIA } from './PaidNonClientPromotionRIA';

export interface EditorialChoiceProps {
  monetizable?: MonetizableEnum;
  isReview?: boolean;
  isRiaOffer?: boolean;
  isFidelityOffer?: boolean;
}

export function EditorialChoice({
  monetizable,
  isReview,
  isRiaOffer,
  isFidelityOffer,
}: EditorialChoiceProps) {
  if (monetizable !== MonetizableEnum.yesAssumed || !isReview) {
    return <DefaultEditorial />;
  }
  if (isRiaOffer && isFidelityOffer) {
    return <PaidNonAdvisoryClientRIA />;
  }
  if (isRiaOffer) {
    return <PaidNonClientPromotionRIA />;
  }
  return <DefaultEditorial />;
}
